module.exports = __webpack_public_path__ + "img/file.890a46a.png";